import axios, { AxiosResponse } from 'axios';
import { ILeiPrevod } from 'types/leiTypes';

export const leiPrevodZalozeni = (lei: string) => {
    return axios({
        method: 'POST',
        url: '/LEI/PrevodLEI/',
        data: {
            lei: lei
        }
    }).then(
        (
            resp: AxiosResponse<{
                varsym: string;
                id: number;
                chybovystav: 'OK';
            }>
        ) => resp.data
    );
};

export const leiPrevodSend = (
    varsym: string,
    idZadosti: number | string,
    method: 'put' | 'post',
    data?: ILeiPrevod
) => {
    return axios({
        method: method,
        url: `LEI/${varsym}/prevodLEI/${idZadosti}`,
        data: data
    }).then((resp: AxiosResponse<{ url: string }>) => resp.data);
};

export const leiPrevodGet = (varsym: string, idZadosti: number | string) => {
    return axios({
        method: 'GET',
        url: `LEI/${varsym}/prevodLEI/${idZadosti}`
    }).then((resp: AxiosResponse<ILeiPrevod>) => resp.data);
};

export const leiPrevodPDF = (varsym: string, idZadosti: number | string, nazev: string) => {
    return axios({
        method: 'GET',
        url: `LEI/${varsym}/prevodLEI/${idZadosti}/pdf`,
        responseType: 'blob' // important
    }).then((resp: { status: number; data: any }) => {
        if (resp.status === 200) {
            // způsob, jak stažený dokument otevřít v browseru
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nav = window.navigator as any;
            // IE
            if (nav?.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(resp.data, nazev);
            } else {
                const odp = resp.data;

                const uriContent = URL.createObjectURL(
                    new Blob([odp], {
                        type: 'application/octetstream'
                    })
                );
                const link = document.createElement('a');
                link.style.display = 'none';
                link.download = nazev;
                link.href = uriContent;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    });
};

export enum EGleifStav {
    OK = 'OK',
    UNAUTHJURISD = 'UNAUTHJURISD', // K této jurisdikci není CDCP akreditována.
    LOUCDCP = 'LOUCDCP' // Zadaný kód LEI je již registrován v CDCP.
}

export interface IGliefData {
    legalentityidentifier: string;
    registrationauthorityentityid: string;
    jurisdikce: string;
    legalname: string;
    registrationstatus: string;
    initialregistrationdate: string;
    lastupdatedate: string;
    nextrenewaldate: string;
    managinglou: string;
    chybovystav: EGleifStav;
}

export const checkGLeifApi = (lei: string) => {
    return axios({
        method: 'GET',
        url: `/LEI/CheckGLEIF?lei=${lei}`
    }).then((resp: AxiosResponse<IGliefData>) => resp.data);
};
